module.exports = __webpack_public_path__ + "images/stickers/taco-angry@2x.88141aecd4c8fbdc3ff1.png";